export const ATUALIZADO = 'Pagamento atualizado'
export const CADASTRADO = 'Pagamento adicionado'
export const NAO_ENCONTRADO = 'Não foram encontrados pagamentos cadastrados'
export const NAO_ENCONTRADO_FILTRO = 'Não há pagamentos com esse filtro'
